import { useSyncExternalStore } from 'react';

interface Options {
  defaultValue: any;
}
function subscribe(listener: () => void) {
  window.addEventListener('storage', listener);

  return () => {
    window.removeEventListener('storage', listener);
  };
}

const useLocalStore = <T,>(key: string, options?: Options) => {
  const defaultValue = options?.defaultValue ?? {};

  function getSnapshot() {
    return localStorage.getItem(key);
  }

  const state = useSyncExternalStore(subscribe, getSnapshot, () => JSON.stringify(defaultValue));

  const changeStoreValue = (newValue: any, notify = true) => {
    localStorage.setItem(key, JSON.stringify(newValue));

    if (notify) window.dispatchEvent(new Event('storage'));
  };

  const removeStoreValue = () => {
    localStorage.removeItem(key);
    window.dispatchEvent(new Event('storage'));
  };

  return {
    dataFromStore: JSON.parse(state ?? JSON.stringify(defaultValue)) as T,
    changeStoreValue,
    removeStoreValue,
  };
};
export default useLocalStore;
